import { z } from 'zod';

export const VerifyPhoneRequestSchema = z.object({
  phoneNumber: z.string().min(1, 'Phone number is required'),
});

export const ConfirmPhoneVerificationRequestSchema = z.object({
  verificationId: z.string().min(1, 'Verification ID is required'),
  code: z.string().min(1, 'Verification code is required'),
});

export const VerifyPhoneResponseSchema = z.object({
  verificationId: z.string(),
  status: z.string(),
  message: z.string().optional(),
});

export const ConfirmPhoneVerificationResponseSchema = z.object({
  isValid: z.boolean(),
  status: z.string(),
  message: z.string().optional(),
});

export const PhoneVerificationRequestSchema = z.object({
  phoneNumber: z.string().min(1, 'Phone number is required'),
});

export type VerifyPhoneRequest = z.infer<typeof VerifyPhoneRequestSchema>;
export type ConfirmPhoneVerificationRequest = z.infer<typeof ConfirmPhoneVerificationRequestSchema>;
export type PhoneVerificationRequest = z.infer<typeof PhoneVerificationRequestSchema>;

export type VerifyPhoneResponse = z.infer<typeof VerifyPhoneResponseSchema>;
export type ConfirmPhoneVerificationResponse = z.infer<typeof ConfirmPhoneVerificationResponseSchema>;
